import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { type GridToolbarProps, Toolbar, useGridRootProps } from '@mui/x-data-grid-pro';

import { isRunningInApp } from '@/utilities/sizeUtils';
import { ToolbarSortItem } from '@/components/common/ToolbarSortItem';
import GridExport from '@/components/common/GridExport';

import { DEFAULT_EXPORT_FILE_NAME } from '../../utils/refuelsExport';

export function RefuelDataGridToolbar({ csvOptions }: GridToolbarProps) {
  const { t } = useTranslation();
  const { listView: isListView } = useGridRootProps();

  return (
    <Box sx={{ p: 0.625, display: 'flex', flexDirection: 'row-reverse' }}>
      <Toolbar>
        {!isRunningInApp() && (
          <GridExport filename={csvOptions?.fileName ?? DEFAULT_EXPORT_FILE_NAME} isListView={isListView} />
        )}
        {isListView && <ToolbarSortItem listView title={t('general.sortBy')} />}
      </Toolbar>
    </Box>
  );
}
